import r from "../managers/braze-instance.js";
import nr from "./dust-provider-factory.js";
export function subscribeToDust() {
  const t = r.l(),
    n = r.nn();
  if (!t || !n) return null;
  const o = nr.o(),
    s = () => {
      if (!o.St()) {
        o.Oe();
        const r = n.rn(() => {
          t.Ye() && o.Xe();
        });
        return r && o.wt(r), o.Ke() && o.qe(), r;
      }
      return o.St();
    };
  return (
    t.Tr(() => {
      r.ao() && (t.Ye() ? (o.Xe(), s()) : (o.Pe(), o.Ke() && o.Ae()));
    }),
    t.Ye() ? s() : null
  );
}
